export const PROFILE_TAB_PROFILE = 'profile';
export const PROFILE_TAB_LISTINGS = 'listings';
export const PROFILE_TAB_REVIEWS_FROM_CUSTOMERS = 'reviews-from-customers';
export const PROFILE_TAB_REVIEWS_AS_BUYER = 'reviews-as-buyer';

export const PROFILE_TABS = [
  PROFILE_TAB_PROFILE,
  PROFILE_TAB_LISTINGS,
  PROFILE_TAB_REVIEWS_FROM_CUSTOMERS,
  PROFILE_TAB_REVIEWS_AS_BUYER,
];

export const DEFAULT_PROFILE_TAB = PROFILE_TAB_PROFILE;

/** Legacy `?tab=reviews` → reviews from customers */
const LEGACY_TAB_ALIASES = {
  reviews: PROFILE_TAB_REVIEWS_FROM_CUSTOMERS,
};

/**
 * Parse `?tab=` from a location search string for the public profile page.
 *
 * @param {string|null|undefined} search e.g. `?tab=listings`
 * @returns {string} one of PROFILE_TABS
 */
export const parseProfileTab = search => {
  if (!search || typeof search !== 'string') {
    return DEFAULT_PROFILE_TAB;
  }
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`);
  const raw = params.get('tab');
  const tab = LEGACY_TAB_ALIASES[raw] || raw;
  return PROFILE_TABS.includes(tab) ? tab : DEFAULT_PROFILE_TAB;
};

/**
 * Build a profile page path search string for a tab.
 * @param {string} tab
 * @returns {string} e.g. `?tab=listings` or `` for default profile tab
 */
export const profileTabSearch = tab => {
  if (!tab || tab === DEFAULT_PROFILE_TAB) {
    return '';
  }
  return `?tab=${tab}`;
};
